import { saas, errors, marketing } from '../services';
import { MessageBox } from 'element-ui';
export default {
	namespaced: true,
	state: {
		info: {},
		loginUserId: null, // 当前登录的用户id
		belongUserId: null, // 归属人用户id
		isSelectCompany: false, // 是否需要进行选择企业
		isPhyManage: false, // 是否是门店管理员
		companyList: [],
		isCompanyMode: true, // 是否为企业版环境	默认是
		isSubAccount: false, // 当前账号是否存在子账户资格
		companyDomain: null, // 当前企业的配置域名
		isAccount: false, // 是否为子账号
		isGetCompanyInfo: false, // 是否获取企业信息
		importPower: false, // 批量短信导入权限
		currentRoleIds: [], //子账号权限列表
		phystoreList: [], // 门店列表
		listInitialized: false, // 门店和企业列表初始化完成
	},
	getters: {
		isManager(state) {
			return state.info.userId === state.loginUserId;
		},
		isCreateActivity(state, getter) {
			return getter.isManager || state.currentRoleIds.includes(23);
		},
		isSubCompany(state, getter) {
			return state.isCompanyMode && !getter.isManager;
		},
		isCompanyAlone(state) {
			return state.info.isAlone;
		},
		// 判断当前企业环境是否过期
		isDueCompany(state) {
			return (
				state.info &&
				((state.info.flagshipCompanyDueDate && new Date().getTime() < state.info.flagshipCompanyDueDate) ||
					(state.info.fullviewCompanyDueDate && new Date().getTime() < state.info.fullviewCompanyDueDate) ||
					(state.info.commerceCompanyDueDate && new Date().getTime() < state.info.commerceCompanyDueDate))
			);
		},
		// 多门店代理员版本(shopSaleType    //企业推广类型 1 推广员版 2 代理员版)
		isShopSaleAgentType(state) {
			return state.info.shopSaleType === 2;
		},
	},
	mutations: {
		listGetFinish(state) {
			state.listInitialized = true;
		},
		SET_INFO(state, payload) {
			state.info = payload;
		},
		SET_BELONG_USER_ID(state, payload) {
			state.belongUserId = payload;
		},
		SET_COMPANYLIST(state, list) {
			state.companyList = list;
		},
		SET_ISSELECTCOMPANY(state, status) {
			state.isSelectCompany = status;
		},

		SET_LOGINUSERID(state, id) {
			state.loginUserId = id;
		},
		SET_ISCOMPANYMODE(state, status) {
			state.isCompanyMode = status;
		},
		SET_ISSUBACCOUNT(state, status) {
			state.isSubAccount = status;
		},
		SET_COMPANYDOMAIN(state, domain) {
			state.companyDomain = domain;
		},
		SET_ISACCOUNT(state, payload) {
			state.isAccount = payload;
		},
		SET_IS_GET_COMPANY_INFO(state, status) {
			state.isGetCompanyInfo = status;
		},
		SET_IMPORT_POWER(state, payload) {
			state.importPower = payload;
		},
		SET_ROLEIDS(state, payload) {
			state.currentRoleIds = payload;
		},
		SET_PHYSTORELIST(state, list) {
			state.phystoreList = list;
		},
		SET_ISPHYMANAGE(state, status) {
			state.isPhyManage = status;
		},
	},
	actions: {
		async getCompanyAndStoreList({ commit }) {
			const [companyIdres, storeListres, companyListres] = await Promise.all([
				saas.getDomainCompanyId(),
				saas.getPhystoreList(),
				saas.getJoinCompanyList(),
			]);
			const companyId = companyIdres.data.data;
			if (companyListres.ok) {
				const companyList = companyId
					? companyListres.data.data.filter((item) => item.id === companyId)
					: companyListres.data.data;
				commit('SET_ISSELECTCOMPANY', false);
				commit('SET_COMPANYLIST', companyList);
			}

			if (storeListres.ok) {
				const storeList = companyId
					? storeListres.data.data.filter((item) => item.companyId === companyId)
					: storeListres.data.data;
				commit('SET_PHYSTORELIST', storeList);
			}
			commit('listGetFinish');
		},
		async getCompanyInfo({ commit, dispatch }, params) {
			try {
				const { data, ok } = await saas.getCompanyInfo();
				if (!ok || !data.data) {
					return;
				}
				commit('SET_ISCOMPANYMODE', true);
				// // 判断当前是否为企业版环境
				// if (
				// 	Date.now() < data.data?.loginCompanyInfo?.fullviewCompanyDueDate ||
				// 	Date.now() < data.data?.loginCompanyInfo?.commerceCompanyDueDate
				// ) {
				// 	commit('SET_ISCOMPANYMODE', true);
				// } else {
				// 	commit('SET_ISCOMPANYMODE', false);
				// }
				// commit('SET_INFO', { certificateStatus: 1 });

				commit('SET_ISSELECTCOMPANY', data.data.isSelectCompany);
				commit('SET_ISPHYMANAGE', data.data.isPhyManage);
				commit('SET_ISSUBACCOUNT', data.data.isSubAccount);
				commit('SET_INFO', data.data.loginCompanyInfo ? data.data.loginCompanyInfo : {});
				commit('SET_LOGINUSERID', data.data.loginUserId ? data.data.loginUserId : null);
				commit('SET_COMPANYDOMAIN', null);
				// commit('SET_ROLEIDS', data.data.userRoleIds);

				if (data.data && data.data.loginCompanyInfo && data.data.loginUserId) {
					commit('SET_BELONG_USER_ID', data.data.loginCompanyInfo.userId);
					if (data.data.loginUserId === data.data.loginCompanyInfo.userId) {
						commit('SET_ISACCOUNT', false);
					} else {
						commit('SET_ISACCOUNT', true);
					}
				} else {
					commit('SET_BELONG_USER_ID', data.data.loginUserId);
					commit('SET_ISACCOUNT', false);
				}
				if (data.data.loginCompanyInfo && data.data.loginCompanyInfo.userId) {
					dispatch('getCompanyDomain', data.data.loginCompanyInfo.userId);
				}
				await dispatch('checkImportPermission');
				commit('SET_IS_GET_COMPANY_INFO', true);
				return data.data;
			} catch (error) {
				errors(error);
			}
		},
		// 升级企业版弹窗
		async updateCompany() {
			await MessageBox.confirm('抱歉，当前版本不支持使用此功能，请升级企业版后使用', '提示', {
				customClass: 'confimDelete',
				confirmButtonText: '立即升级',
				type: 'warning',
			})
				.then(() => {
					const href = `${location.origin}/purchase/service?priceType=56`;
					window.open(href, '_blank');
				})
				.catch((e) => {
					return;
				});
		},

		async getCompanyDomain({ commit }, userId) {
			try {
				const { data, ok } = await saas.getCompanyDomain(userId);
				if (!ok) {
					return;
				}
				commit('SET_COMPANYDOMAIN', data.data);
			} catch (error) {
				errors(error);
			}
		},
		async checkImportPermission({ state, commit }) {
			try {
				const { ok, data } = await marketing.getWhite({
					userId: state.belongUserId,
				});
				if (!ok) {
					return;
				}

				commit('SET_IMPORT_POWER', data.data);
			} catch (err) {
				errors(err);
			}
		},
	},
};
